<div #sectionSubscribe></div>
<app-navsec></app-navsec>
<div class="container animated fadeIn">
    <div class="clo-lg-12 text-center">
        <img *ngIf="film == 'No'" [src]="imagen" class="img-fluid" width="60%" alt="Responsive image">
        <div *ngIf="film == 'Si'">
          <iframe width="560" height="315" [src]="urlSafe" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>        </div>
        <h3 class="mt-3"><b>{{titulo}}</b></h3>
        <hr>
    </div>
    <div class="col-lg-12">
        <p *ngFor="let item of contenido" style="text-align: justify;">{{item}}</p>
    </div>
    <div class="col-lg-12 text-right">
        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
            Comentar artículo
          </button>
    </div>
    <div class="col-lg-10 mt-5">
        <h4>Comentarios:</h4>
        <div class="card" *ngFor="let comentario of comentarios">
            <div class="card-header text-right">
                Autor: <b style="color: rgb(11, 11, 187); font-size: 12px;">{{comentario.autor}}</b>
            </div>
            <div class="card-body">
                <p class="card-text">{{comentario.comentario}}</p>
            </div>
            <div class="card-footer text-muted text-center">
                {{comentario.fecha | date}}
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Hacer comentario</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body" style="background-color: #fff;">
                <form [formGroup]="comentariosForm" (ngSubmit)="comentar(comentariosForm.value)">
                    <label for="">Su correo:</label>
                    <input type="email" class="form-control" placeholder="Ingrese e-mail" formControlName="email"><br>
                    <label for="">Comentario:</label>
                    <textarea class="form-control" name="" id="" cols="30" rows="5" formControlName="comentario"></textarea><br>
                    <button type="submit" class="btn btn-primary">Enviar Comentario</button>
                </form>
            </div>
            <div class="modal-footer">
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
